(function () {
  function langFromPath() {
    var path = location.pathname || '';
    if (/^\/en(\/|$)/i.test(path)) return 'en';
    if (/^\/de(\/|$)/i.test(path)) return 'de';
    return '';
  }

  var lang = langFromPath() || 'nl';
  if (lang !== 'en' && lang !== 'de') return;

  var col = lang === 'de' ? 2 : 1;

  var labels = [
    ['VERZENDING', 'SHIPPING', 'VERSAND'],
    ['Verzending', 'Shipping', 'Versand'],
    ['LIDMAATSCHAP', 'MEMBERSHIP', 'MITGLIEDSCHAFT'],
    ['Lidmaatschap', 'Membership', 'Mitgliedschaft'],
    ['UITSTEKEND', 'EXCELLENT', 'AUSGEZEICHNET'],
    ['Uitstekend', 'Excellent', 'Ausgezeichnet'],
    ['Anoniem', 'Anonymous', 'Anonym'],
    ['Privacybeleid', 'Privacy policy', 'Datenschutz'],
    ['Retourbeleid', 'Return policy', 'Rückgaberichtlinie'],
    ['Terugbetalingsbeleid', 'Refund policy', 'Rückerstattungsrichtlinie'],
    ['Algemene voorwaarden', 'Terms of service', 'AGB'],
    ['Servicevoorwaarden', 'Terms of service', 'AGB'],
    ['Verzendbeleid', 'Shipping policy', 'Versandrichtlinie'],
    ['Cookiebeleid', 'Cookie policy', 'Cookie-Richtlinie'],
    ['Contactgegevens', 'Contact details', 'Kontaktdaten'],
    ['Klantenservice', 'Customer service', 'Kundenservice'],
    ['Veelgestelde vragen', 'Frequently asked questions', 'Häufig gestellte Fragen'],
    ['Over ons', 'About us', 'Über uns'],
    ['Vacatures', 'Vacancies', 'Stellenangebote'],
    ['Carrière', 'Career', 'Karriere'],
    ['Recensies', 'Reviews', 'Bewertungen'],
    ['Onze winkel', 'Our store', 'Unser Store'],
    ['Fysieke winkel', 'Physical store', 'Ladengeschäft'],
    ['INFORMATIE', 'INFORMATION', 'INFORMATION'],
    ['WINKEL', 'SHOP', 'SHOP'],
    ['BELEID', 'POLICY', 'RICHTLINIEN'],
    ['-> WORD LID', '-> JOIN', '-> MITGLIED WERDEN'],
    ['WORD LID VAN DE MILLION-FAMILIE EN VERDIEN PUNTEN OP ALLE BESTELLINGEN', 'JOIN THE MILLION FAMILY AND EARN POINTS ON EVERY ORDER', 'WERDE TEIL DER MILLION-FAMILIE UND SAMMLE PUNKTE BEI JEDER BESTELLUNG'],
    ['Verzenden', 'Shipping', 'Versand'],
    ['Retourneren', 'Returns', 'Rückgabe'],
    ['Dames', 'Women', 'Damen'],
    ['Heren', 'Men', 'Herren'],
    ['Mannen', 'Men', 'Herren'],
    ['Kinderen', 'Kids', 'Kinder'],
    ['Taal', 'Language', 'Sprache'],
    ['Hoe retourneren :', 'How to return:', 'So sendest du zurück:'],
    ['Hoe Returns :', 'How to return:', 'So sendest du zurück:'],
    ['Sorteren op', 'Sort by', 'Sortieren nach'],
    ['Filteren en sorteren', 'Filter and sort', 'Filtern und sortieren'],
    ['Filteren', 'Filter', 'Filtern'],
    ['Toepassen', 'Apply', 'Anwenden'],
    ['Uitgelicht', 'Featured', 'Vorgestellt'],
    ['Meest relevant', 'Most relevant', 'Relevanteste'],
    ['Best verkopende', 'Best selling', 'Meistverkaufte'],
    ['Alfabetisch: A-Z', 'Alphabetically: A-Z', 'Alphabetisch: A-Z'],
    ['Alfabetisch: Z-A', 'Alphabetically: Z-A', 'Alphabetisch: Z-A'],
    ['Prijs: laag naar hoog', 'Price: low to high', 'Preis: niedrig nach hoch'],
    ['Prijs: hoog naar laag', 'Price: high to low', 'Preis: hoch nach niedrig'],
    ['Datum: oud naar nieuw', 'Date: old to new', 'Datum: alt nach neu'],
    ['Datum: nieuw naar oud', 'Date: new to old', 'Datum: neu nach alt'],
    ['ONTDEK DE ZOMERUITVERKOOP', 'DISCOVER THE SUMMER SALE', 'ENTDECKE DEN SOMMERSALE'],
    ['Ontdek de zomeruitverkoop', 'Discover the summer sale', 'Entdecke den Sommersale'],
    ['ALLE MERKEN', 'ALL BRANDS', 'ALLE MARKEN'],
    ['Alle merken', 'All brands', 'Alle Marken'],
    ['Ontdek nieuw binnen', 'Discover New In', 'Entdecke Neuheiten'],
    ['Discover New In', 'Discover New In', 'Entdecke Neuheiten'],
    ['ALLE NIEUW BINNEN', 'ALL NEW IN', 'ALLE NEUHEITEN'],
    ['ALLE BESTSELLERS', 'ALL BESTSELLERS', 'ALLE BESTSELLER'],
    ['ALLE SALE', 'ALL SALE', 'ALLE SALE'],
    ['MANNEN BESTSELLERS', 'MEN BESTSELLERS', 'HERREN BESTSELLER'],
    ['DAMES BESTSELLERS', 'WOMEN BESTSELLERS', 'DAMEN BESTSELLER'],
    ['KINDEREN BESTSELLERS', 'KIDS BESTSELLERS', 'KINDER BESTSELLER'],
    ['MANNEN NIEUW BINNEN', 'MEN NEW IN', 'HERREN NEUHEITEN'],
    ['DAMES NIEUW BINNEN', 'WOMEN NEW IN', 'DAMEN NEUHEITEN'],
    ['KINDEREN NIEUW BINNEN', 'KIDS NEW IN', 'KINDER NEUHEITEN'],
    ['MANNEN SALE', 'MEN SALE', 'HERREN SALE'],
    ['DAMES SALE', 'WOMEN SALE', 'DAMEN SALE'],
    ['KINDEREN SALE', 'KIDS SALE', 'KINDER SALE'],
    ['MERKEN', 'BRANDS', 'MARKEN'],
    ['KLEDING', 'CLOTHING', 'KLEIDUNG'],
    ['BROEKEN', 'TROUSERS', 'HOSEN'],
    ['ACCESSOIRES', 'ACCESSORIES', 'ACCESSOIRES'],
    ['SCHOENEN', 'SHOES', 'SCHUHE'],
    ['JASSEN', 'JACKETS', 'JACKEN'],
    ['TRUIEN', 'SWEATERS', 'PULLOVER'],
    ['JURKEN', 'DRESSES', 'KLEIDER'],
    ['ROKKEN', 'SKIRTS', 'RÖCKE'],
    ['TASSEN', 'BAGS', 'TASCHEN'],
    ['SIERADEN', 'JEWELRY', 'SCHMUCK']
  ];

  var paragraphs = [
    [
      'Indien je niet tevreden bent over je bestelling, mag je via onze webshop binnen 14 dagen na betaling van de bestelling het artikel retourneren. Let op: de retourkosten zijn voor eigen rekening.',
      'If you are not satisfied with your order, you may return the item via our webshop within 14 days after payment. Please note: return shipping is at your own expense.',
      'Wenn du mit deiner Bestellung nicht zufrieden bist, kannst du den Artikel innerhalb von 14 Tagen nach Zahlung über unseren Webshop zurücksenden. Die Rücksendekosten trägst du selbst.'
    ],
    [
      'Indien je niet tevreden bent over je bestelling, mag je via onze webshop binnen 14 dagen na betaling van de bestelling het artikel Returns. Let op: de retourkosten zijn voor eigen rekening.',
      'If you are not satisfied with your order, you may return the item via our webshop within 14 days after payment. Please note: return shipping is at your own expense.',
      'Wenn du mit deiner Bestellung nicht zufrieden bist, kannst du den Artikel innerhalb von 14 Tagen nach Zahlung über unseren Webshop zurücksenden. Die Rücksendekosten trägst du selbst.'
    ],
    [
      'Verzending heen & Retouren kosten je al snel 12-14 euro heen en terug, maak een bewuste keuze.',
      'Outbound and return shipping often costs around 12–14 euros both ways, so please choose carefully.',
      'Hin- und Rückversand kosten oft 12–14 Euro, triff also eine bewusste Entscheidung.'
    ],
    [
      'Verzending heen & retour kosten je al snel 12-14 euro heen en terug, maak een bewuste keuze.',
      'Outbound and return shipping often costs around 12–14 euros both ways, so please choose carefully.',
      'Hin- und Rückversand kosten oft 12–14 Euro, triff also eine bewusste Entscheidung.'
    ],
    [
      'Meld je retour aan op de website via je account. (Als je het mailadres invult waarmee je de bestelling hebt geplaatst, krijg je een code gestuurd. Je hoeft dus geen account aan te maken).',
      'Register your return on the website via your account. (If you enter the email address used for the order, you will receive a code. You do not need to create an account.)',
      'Melde deine Rücksendung auf der Website über dein Konto. (Wenn du die E-Mail-Adresse der Bestellung eingibst, erhältst du einen Code. Du musst kein Konto erstellen.)'
    ],
    [
      'Schrijf op een papier je naam en bestelnummer en stuur deze mee ( anders kunnen wij niet terugbetalen omdat we niet weten van wie het product is )',
      'Write your name and order number on a piece of paper and include it (otherwise we cannot refund because we do not know who the product belongs to).',
      'Schreibe deinen Namen und die Bestellnummer auf ein Papier und lege es bei (sonst können wir nicht erstatten, weil wir nicht wissen, wem das Produkt gehört).'
    ],
    [
      'Zorg ervoor dat de bestaande sticker niet meer op jouw pakketje zit.',
      'Make sure the existing shipping label is no longer on your parcel.',
      'Achte darauf, dass der alte Versandaufkleber nicht mehr auf dem Paket ist.'
    ]
  ];

  function applyCase(src, dest) {
    if (!src || !dest) return dest;
    if (src === src.toUpperCase() && /[A-ZÀ-ÿ]/.test(src)) return dest.toUpperCase();
    if (src[0] === src[0].toUpperCase()) return dest.charAt(0).toUpperCase() + dest.slice(1);
    return dest;
  }

  function translateExact(text) {
    var raw = text || '';
    var trimmed = raw.replace(/\s+/g, ' ').trim();
    if (!trimmed) return raw;

    var p;
    for (p = 0; p < paragraphs.length; p++) {
      if (trimmed === paragraphs[p][0].replace(/\s+/g, ' ').trim()) {
        return raw.replace(raw.trim(), paragraphs[p][col]);
      }
    }

    var i;
    for (i = 0; i < labels.length; i++) {
      if (trimmed.toLowerCase() === labels[i][0].toLowerCase()) {
        return raw.replace(raw.trim(), applyCase(trimmed, labels[i][col]));
      }
    }
    return raw;
  }

  function walk(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentElement && node.parentElement.closest('[data-keep-lang], script, style, noscript, code, textarea, input, select')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var n = 0; n < nodes.length; n++) {
      var next = translateExact(nodes[n].nodeValue);
      if (next !== nodes[n].nodeValue) nodes[n].nodeValue = next;
    }
  }

  function run() {
    walk(document.querySelector('.footer, .footer--million, [data-i18n-footer]'));
    walk(document.querySelector('.shopify-policy__body'));
    walk(document.querySelector('.shopify-policy__title'));
    walk(document.querySelector('[class*="jdgm"], .reviews-carousel, .shopify-section--reviews'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
